import { lazy } from "react";
import { getEnviroment } from "@/utils/enviromentUtils";
import type { RouteObject } from "react-router-dom";

const LoginPage = lazy(() => import("@/pages/dev/Login"));

const config: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
];

export const getDebugModeRouteConfig = () => {
  if (getEnviroment() === "prod") {
    return [];
  }
  return config;
};
